import styled from 'styled-components';

import { colors, textStyles } from 'theme/theme';

export const LanguageLinksContainer = styled.div`
  display: inline-flex;

  a,
  div {
    display: block;
    position: relative;
    margin: 0 12px;

    color: ${colors.lightContentGrey};
    ${textStyles.bodySmall}

    &, * {
      line-height: 1.25;
    }

    &:not(:first-child) {
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -12px;
        height: 1em;
        width: 1px;
        background: currentColor;
        pointer-events: none;
      }
    }
  }
`;
